var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 64,
    viewBox: "0 0 79 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 0.599995V14.8C19.6 16.4 15.2 24 15.2 32.2H32V63.4H0.600001V34.6C0.600001 14.6 12.8 2.59999 30.6 0.599995ZM76.6 0.599995V14.8C65.6 16.4 61.4 24 61.4 32.2H78.2V63.4H46.6V34.6C46.6 14.6 58.8 2.59999 76.6 0.599995Z",
    fill: "#22A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageicon);
export default __webpack_public_path__ + "static/media/Messageicon.0e636887eac2966bf1724b407641fba4.svg";
export { ForwardRef as ReactComponent };